/**
 * viewport-fix — Compensa il "buco" sotto la bottom nav su Chrome iOS.
 *
 * Su Chrome iOS, quando la toolbar inferiore si nasconde durante lo scroll,
 * il layout viewport (a cui `position: fixed; bottom: 0` si aggancia) NON
 * viene ridimensionato: la nav resta sospesa lasciando uno spazio vuoto.
 * Safari iOS e Android Chrome ridimensionano il viewport correttamente,
 * quindi su quei browser questo calcolo restituisce sempre 0.
 *
 * Espone:
 *  --ik-viewport-bottom-offset (CSS var su <html>): px da compensare via translateY
 *  classe ik-keyboard-open su <html>: presente quando la tastiera è probabilmente aperta
 */

const KEYBOARD_THRESHOLD_PX = 150;

export function initViewportFix() {
    const vv = window.visualViewport;
    if (!vv) return;

    const root = document.documentElement;
    let frame = null;

    const update = () => {
        frame = null;
        const innerHeight = window.innerHeight;
        const visualBottom = vv.height + vv.offsetTop;
        const gap = Math.max(0, innerHeight - visualBottom);

        if (gap > KEYBOARD_THRESHOLD_PX) {
            root.style.setProperty('--ik-viewport-bottom-offset', '0px');
            root.classList.add('ik-keyboard-open');
        } else {
            root.style.setProperty('--ik-viewport-bottom-offset', `${gap}px`);
            root.classList.remove('ik-keyboard-open');
        }
    };

    const schedule = () => {
        if (frame !== null) return;
        frame = requestAnimationFrame(update);
    };

    vv.addEventListener('resize', schedule);
    vv.addEventListener('scroll', schedule);
    update();
}
